module.exports = __webpack_public_path__ + "static/media/solutions-grid-2.429311b4.webp";